module.exports = __webpack_public_path__ + "static/media/chevron-down.80d16042.svg";